import type { NodeViewRenderers } from 'ricos-types';
import { Node_Type } from 'ricos-types';

import Html from './html';

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.HTML]: Html,
};
